var QuizData = [
		{
			name:"frage_1",
			frage : 'What is the difference between "Sadnecessary" and "Blossom"?',
			was_asked : false,
			video : "01_question.mp4",
			userQuestion: [{ 
					frage : "What changed from the first album, Sadnecessary to the second album, Blossom?",
					answer : [
							{
								text : "Clemens and Philipp grew up",
								correct : false,
							},
							{
								text : "Clemens and Philipp both went through break-ups",
								correct : false,
							},
							{
								text : "Clemens and Philipp used more instruments",
								correct : true,
							}
					]
				},{ 
					frage : "How many lamps can you see in the video?",
					answer : [
							{
								text : "1",
								correct : true,
							},
							{
								text : "2",
								correct : false,
							},
							{
								text : "3",
								correct : false,
							}
					]
				},{ 
					frage : "When they first started Milky Chance, Clemens and Philipp didn't have any..",
					answer : [
							{
								text : "Fun",
								correct : false,
							},
							{
								text : "Equipment",
								correct : true,
							},
							{
								text : "Friends",
								correct : false,
							}
					]
				}]
		},
		{
			name:"frage_2",
			frage : "It's been a wild ride for you since you recorded your debut album. How have you changed personally since then?",
			was_asked : false,
			video : "02_question.mp4",//"MC_IA_3_changedpersonally_1.mp4",
			userQuestion: [{ 
					frage : "What is Clemens hoping for?",
					answer : [
							{
								text : "That fans will like his new hair cut",
								correct : false,
							},
							{
								text : "That he gets better as a musician",
								correct : true,
							},
							{
								text : "To play more concerts in 2017",
								correct : false,
							}
					]
				},{ 
					frage : "How many years have passed since the last album, Sadnecessary?",
					answer : [
							{
								text : "5 years",
								correct : false,
							},
							{
								text : "3 years",
								correct : false,
							},
							{
								text : "4 years",
								correct : true,
							}
					]
				},{ 
					frage : "Clemens and Philipp still live in the same city - where is that?",
					answer : [
							{
								text : "Berlin",
								correct : false,
							},
							{
								text : "Hamburg",
								correct : false,
							},
							{
								text : "Kassel",
								correct : true,
							}
					]
				}]
		},
		{
			name:"frage_3",
			frage : "What isn't so glorious about life on the road?",
			was_asked : false,
			video : "03_question.mp4",
			userQuestion: [{ 
					frage : "How many rings does Philipp wear on his left hand?",
					answer : [
							{
								text : "Two",
								correct : false,
							},
							{
								text : "None",
								correct : false,
							},
							{
								text : "One",
								correct : true,
							}
					]
				},{ 
					frage : "How many hours do Milky Chance spend traveling monthly?",
					answer : [
							{
								text : "200 per month",
								correct : false,
							},
							{
								text : "60 per month",
								correct : false,
							},
							{
								text : "They didn't say it, but sounds like a lot!",
								correct : true,
							}
					]
				},{ 
					frage : "How many hours do Milky Chance spend traveling monthly?",
					answer : [
							{
								text : "200 per month",
								correct : false,
							},
							{
								text : "60 per month",
								correct : false,
							},
							{
								text : "They didn't say it, but sounds like a lot!",
								correct : true,
							}
					]
				}]
		},
		{
			name:"frage_4",
			frage : "What was the most challenging moment on stage?",
			was_asked : false,
			video : "04_question.mp4",
			userQuestion: [{ 
					frage : "How long was their first headline tour in North America?",
					answer : [
							{
								text : "5 months",
								correct : false,
							},
							{
								text : "1 year",
								correct : false,
							},
							{
								text : "3 months",
								correct : true,
							}
					]
				},{
					frage : "When Clemens got sick at Coachella Weekend 1 in 2015, after how many songs did they have to quit playing?",
					answer : [
							{
								text : "1 song",
								correct : false,
							},
							{
								text : "2 songs",
								correct : true,
							},
							{
								text : "4 songs",
								correct : false,
							}
					]
				},{ 
					frage : "What does Philipp compare the loss of Clemens' voice with?",
					answer : [
							{
								text : "Being sick on Halloween",
								correct : false,
							},
							{
								text : "Like a skier losing his feet",
								correct : true,
							},
							{
								text : "Like an actor forgetting his script",
								correct : false,
							}
					]
				}]
		},
		{
			name:"frage_5",
			frage : "What was the most impressive venue you’ve played?",
			was_asked : false,
			video : "05_question.mp4",
			userQuestion: [{ 
					frage : "What is so impressive about playing at ”Red Rocks Amphitheater” in Colorado?",
					answer : [
							{
								text : "The beautiful red color of the rocks",
								correct : false,
							},
							{
								text : "The wall of people standing in front of you",
								correct : true,
							},
							{
								text : "The hike to get to the main stage",
								correct : false,
							}
					]
				},{ 
					frage : "What was the earliest notable rock-and-roll performance at ”Red Rocks”?",
					answer : [
							{
								text : "Neil Young",
								correct : false,
							},
							{
								text : "The Beatles",
								correct : true,
							},
							{
								text : "Incubus",
								correct : false,
							}
					]
				},{ 
					frage : "What is lying in front of the boys on the table?",
					answer : [
							{
								text : "Some books",
								correct : false,
							},
							{
								text : "Some vinyls",
								correct : false,
							},
							{
								text : "Some photos",
								correct : true,
							}
					]
				}]
		},
		{
			name:"frage_6",
			frage : "What was the most spontaneous thing you've ever done before going on stage?",
			was_asked : false,
			video : "06_question.mp4",
			userQuestion: [{ 
					frage : "Where did Clemens and Philipp jam with a complete stranger?",
					answer : [
							{
								text : "Los Angeles",
								correct : true,
							},
							{
								text : "New York",
								correct : false,
							},
							{
								text : "Boston",
								correct : false,
							}
					]
				},{ 
					frage : "At Clemens and Philipp’s first gig in LA, why did a stranger drive away with his car?",
					answer : [
							{
								text : "To pick up his bongos",
								correct : true,
							},
							{
								text : "To pick up his guitar",
								correct : false,
							},
							{
								text : "To go pick up some beer",
								correct : false,
							}
					]
				},{ 
					frage : "What was the name of the guy they jammed with in LA?",
					answer : [
							{
								text : "Juan",
								correct : true,
							},
							{
								text : "Walter",
								correct : false,
							},
							{
								text : "A girl named Jessica",
								correct : false,
							}
					]
				}]
		},
		{
			name:"frage_7",
			frage : "How does traveling on tour look?",
			was_asked : false,
			video : "07_question.mp4",
			userQuestion: [{ 
					frage : "How many boys fit into Clemens and Philipp’s first tour ‘van’?",
					answer : [
							{
								text : "18",
								correct : false,
							},
							{
								text : "9",
								correct : true,
							},
							{
								text : "Only these two handsome fellas",
								correct : false,
							}
					]
				},{ 
					frage : "Which type of tour bus do Clemens and Philipp prefer?",
					answer : [
							{
								text : "German",
								correct : false,
							},
							{
								text : "American",
								correct : true,
							},
							{
								text : "Japanese",
								correct : false,
							}
					]
				},{ 
					frage : "What is the coolest thing about a tour bus according to Clemens and Philipp?",
					answer : [
							{
								text : "The booze",
								correct : false,
							},
							{
								text : "The coziness",
								correct : false,
							},
							{
								text : "The beds",
								correct : true,
							}
					]
				}]
		},
		{
			name:"frage_8",
			frage : "When playing live, why are there three band members on stage instead of two?",
			was_asked : false,
			video : "09_question.mp4",
			userQuestion: [{ 
					frage : "Where is Potsdam?",
					answer : [
							{
								text : "Near Berlin",
								correct : true,
							},
							{
								text : "Somewhere over the rainbow",
								correct : false,
							},
							{
								text : "Near New York City",
								correct : false,
							}
					]
				},{ 
					frage : "Nowadays, how many band-members are in Milky Chance",
					answer : [
							{
								text : "3",
								correct : true,
							},
							{
								text : "As many as Arcade Fire",
								correct : false,
							},
							{
								text : "6",
								correct : false,
							}
					]
				},{ 
					frage : "Which instrument does the newest band member, Antonio, play?",
					answer : [
							{
								text : "Bagpipes",
								correct : false,
							},
							{
								text : "Harmonica",
								correct : true,
							},
							{
								text : "Saxophone",
								correct : false,
							}
					]
				}]
			
		},
		{
			name:"frage_9",
			frage : "Do audience members differ from country to country?",
			was_asked : false,
			video : "10_question.mp4",
			userQuestion: [{ 
					frage : "Who started the crazy ”Shuffle Dance” at The Falls Festival in Byron Bay?",
					answer : [
							{
								text : "All together",
								correct : false,
							},
							{
								text : "Four guys on a hill",
								correct : true,
							},
							{
								text : "The band itself",
								correct : false,
							}
					]
				},{ 
					frage : "During which song did the lovely people of Byron Bay do the “Shuffle Dance“ all together?",
					answer : [
							{
								text : "Loveland",
								correct : false,
							},
							{
								text : "Sweet Sun",
								correct : true,
							},
							{
								text : "Stolen Dance",
								correct : false,
							}
					]
				},{ 
					frage : "What is the first single of the new album, Blossom, called?",
					answer : [
							{
								text : "Cocoon",
								correct : true,
							},
							{
								text : "In Bloom",
								correct : false,
							},
							{
								text : "Danger Room",
								correct : false,
							}
					]
				}]

		},
		{
			name:"frage_10",
			frage : "5 things you always take on the road?",
			was_asked : false,
			video : "08_question.mp4",//"MC_IA_12_doaudiencediffer_combined.mp4",
			userQuestion: [{ 
					frage : "While on tour, who takes a book on the road?",
					answer : [
							{
								text : "always by Clemens",
								correct : false,
							},
							{
								text : "always by both",
								correct : false,
							},
							{
								text : "sometimes by Clemens, but always by Philipp",
								correct : true,
							}
					]
				},{ 
					frage : "While on tour, where does the band like to hang out when they have some time off?",
					answer : [
							{
								text : "At the pool",
								correct : false,
							},
							{
								text : "At a basketball court",
								correct : true,
							},
							{
								text : "In their hotel rooms",
								correct : false,
							}
					]
				},{ 
					frage : "What kind of sport balls do the band take with them on the road?",
					answer : [
							{
								text : "Football and Basketball",
								correct : true,
							},
							{
								text : "Basketball and Volleyball",
								correct : false,
							},
							{
								text : "Volleyball and Football",
								correct : false,
							}
					]
				}]
		}
	];

export default QuizData;



// WEBPACK FOOTER //
// ./src/scripts/chapter2/quizData.js